import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQuerySurveyGroups = () => {
  const brandAccount = useMainQueryData()

  return React.useMemo(
    () => brandAccount?.surveyGroups ?? [],
    [brandAccount?.surveyGroups],
  )
}
